module.exports = __webpack_public_path__ + "static/media/Money-Bag-Market-Growth.bf5c339d.svg";